
<div class="main-layout-grid">
  <main id="main-container">
    <div class="data-content custom-height center">
      <div class="content-width">
        <app-left-part></app-left-part>
      </div>
      <div class="content-width right">
        <div class="right-side-content before-login-page">
          <div class="container">
            <div class="form-details">
              <div class="forms-data">
                <form class="reset-pass-form" [formGroup]="passwordRequestForm" (ngSubmit)="onSubmit()">
                  <div class="form-block-title">
                    <h3 class="form-title">Enter email to receive activation link </h3>
                    <div class="form-inputs-data">
                      <div class="form-group" maxlength="50" [class.error]="((passwordRequestForm.get('email')!.touched ||
                      passwordRequestForm.get('email')!.dirty) &&
                      passwordRequestForm.get('email')!.errors)">
                        <input type="text" class="form-control form-input" name="email" id="email" formControlName="email" placeholder=" ">
                        <label class="form-label">Email</label>
                        <div class="form-icon">
                          <svg class="email-icon" id="icons_ic-mail" data-name="icons / ic-mail" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                            <rect id="Rectangle_454" data-name="Rectangle 454" width="24" height="24" fill="none" />
                            <path id="alternate_email_FILL0_wght300_GRAD0_opsz24" class="fill-color" d="M12,21.5a9.263,9.263,0,0,1-3.712-.75A9.432,9.432,0,0,1,3.25,15.712,9.263,9.263,0,0,1,2.5,12a9.24,9.24,0,0,1,.75-3.725A9.466,9.466,0,0,1,8.288,3.25,9.263,9.263,0,0,1,12,2.5a9.24,9.24,0,0,1,3.725.75A9.5,9.5,0,0,1,20.75,8.275,9.24,9.24,0,0,1,21.5,12v1.225a3.183,3.183,0,0,1-.938,2.325,3.119,3.119,0,0,1-2.312.95,3.141,3.141,0,0,1-2.825-1.625,5.11,5.11,0,0,1-1.462,1.175A4.089,4.089,0,0,1,12,16.5,4.48,4.48,0,0,1,7.5,12,4.48,4.48,0,0,1,12,7.5,4.48,4.48,0,0,1,16.5,12v1.225a1.75,1.75,0,1,0,3.5,0V12a7.7,7.7,0,0,0-2.363-5.638A7.7,7.7,0,0,0,12,4,7.7,7.7,0,0,0,6.362,6.362,7.7,7.7,0,0,0,4,12a7.7,7.7,0,0,0,2.362,5.637A7.7,7.7,0,0,0,12,20h4.25a.75.75,0,1,1,0,1.5ZM12,15a2.988,2.988,0,0,0,3-3,2.988,2.988,0,0,0-3-3,2.988,2.988,0,0,0-3,3,2.988,2.988,0,0,0,3,3Z" transform="translate(-0.5 -0.5)" fill="#757575" />
                          </svg>
                        </div>
                        <app-error [controlName]="passwordRequestForm.controls['email']">
                        </app-error>
                      </div>
                    </div>
                    <validation-summary [validationErrors]="errorMessages" [isError]="isError"></validation-summary>
                    <div class="action-btn">
                      <!--<button type="submit" class="btn commn-btn disabled">Reset Password</button>-->
                      <button type="submit" class="btn commn-btn width-100">Continue</button>
                      <a href="javascript:void()" routerLink="/login" class="btn commn-btn-plain">Back</a>
                    </div>
                  </div>
                </form>
                <div class="agent-note outside-tooltip">
                  <div class="tooltip-block">
                    <div class="tooltip-data-show">
                      <svg class="tooltip-info" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <rect id="Rectangle_18062" data-name="Rectangle 18062" width="24" height="24" fill="none" />
                        <path id="info_FILL0_wght300_GRAD0_opsz24" d="M12,16.75a.725.725,0,0,0,.75-.75V11.725a.7.7,0,0,0-.212-.513.751.751,0,0,0-1.288.538v4.275a.7.7,0,0,0,.213.513A.728.728,0,0,0,12,16.75ZM12,9.3a.757.757,0,0,0,.575-.238.82.82,0,0,0,.225-.587.792.792,0,0,0-.225-.563.816.816,0,0,0-1.15,0,.792.792,0,0,0-.225.563.82.82,0,0,0,.225.587A.757.757,0,0,0,12,9.3Zm0,12.2a9.263,9.263,0,0,1-3.712-.75A9.432,9.432,0,0,1,3.25,15.712a9.563,9.563,0,0,1,0-7.425A9.435,9.435,0,0,1,8.288,3.25a9.563,9.563,0,0,1,7.425,0A9.437,9.437,0,0,1,20.75,8.287a9.563,9.563,0,0,1,0,7.425,9.435,9.435,0,0,1-5.037,5.038A9.27,9.27,0,0,1,12,21.5ZM12,12Zm0,8a7.714,7.714,0,0,0,5.663-2.337A7.714,7.714,0,0,0,20,12a7.714,7.714,0,0,0-2.337-5.663A7.714,7.714,0,0,0,12,4,7.711,7.711,0,0,0,6.338,6.337,7.713,7.713,0,0,0,4,12a7.713,7.713,0,0,0,2.338,5.663A7.711,7.711,0,0,0,12,20Z" fill="#424242" />
                      </svg>
                      <p class="tooltip-text">tool-tip</p>
                    </div>
                    <h3 class="agent-name">For Agent</h3>
                  </div>
                  <p class="agent-info">If you're an agent or adjuster, Please contact your administrator to activate your account.</p>
                </div>
              </div>
            </div>
          </div>
          <app-footer></app-footer>
        </div>

      </div>
    </div>
  </main>
</div>
